import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  offerContainer: {
    backgroundColor: "#598392",
    borderRadius: "8px",
    padding: theme.spacing(2),
    textAlign: "center",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    marginTop: theme.spacing(1),
    marginInline: "25px",
    display: "block",
    width: "fit-content",
    [theme.breakpoints.down("sm")]: {
      margin: "25px",
    },
  },
  riyalIcon: {
    display: "inline-block",
    height: "0.85em",
    width: "0.76em",
    marginInline: "0.15em",
    verticalAlign: "-0.08em",
    fill: "currentColor",
  },
  offerText: {
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "1.5rem",
    lineHeight: 1.6,
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.125rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
    },
  },
}));

